import { AlertTriangle, X } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { useMe } from '../auth/queries';

import { usePendingReviews } from './queries';
import { useDismissReviewBanner } from './useDismissReviewBanner';

export function PendingReviewBanner() {
  const me = useMe();
  const pending = usePendingReviews();
  const { hidden, dismiss } = useDismissReviewBanner(me.data?.id ?? null);
  const count = pending.data?.count ?? 0;

  if (hidden || count === 0) return null;

  const oldest = pending.data?.oldestAgeDays ?? 0;
  const danger = oldest > 7;
  const text = `${count} trade ${count === 1 ? 'review' : 'reviews'} pending · oldest ${oldest} ${
    oldest === 1 ? 'day' : 'days'
  }`;

  return (
    <div className="flex flex-col gap-3 rounded border border-border bg-surface px-4 py-3 text-sm text-text sm:flex-row sm:items-center sm:justify-between">
      <div className="flex min-w-0 items-center gap-3">
        <AlertTriangle
          className={`h-5 w-5 shrink-0 ${danger ? 'text-danger' : 'text-warn'}`}
          aria-hidden="true"
        />
        <div className="flex min-w-0 flex-wrap items-center gap-2">
          <Badge tone={danger ? 'danger' : 'warning'}>{danger ? 'Overdue' : 'Review due'}</Badge>
          <span className="font-medium">{text}</span>
        </div>
      </div>
      <div className="flex items-center gap-2 self-end sm:self-auto">
        <Button asChild size="sm" variant="secondary">
          <Link to="/reviews">Review trades</Link>
        </Button>
        <button
          type="button"
          className="inline-flex h-8 w-8 items-center justify-center rounded text-current hover:bg-bg/20"
          aria-label="Hide review banner for 24 hours"
          onClick={dismiss}
        >
          <X className="h-4 w-4" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
